export interface Partner {
  id: number;
  imageUrl: string;
  logoUrl: string;
  name: string;
  description: string;
  verified: boolean;
  category: string;
}

export const partnersData: Partner[] = [
  {
    id: 1,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company1.com/logo.png",
    name: "홍띠",
    description: "3D모델링과 픽셀아트를 병행하는 묘델러",
    verified: true,
    category: "3D 모델링",
  },
  {
    id: 2,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company2.com/logo.png",
    name: "김루인",
    description: "10년차 마인크래프트 스킨제작자",
    verified: true,
    category: "마인크래프트 스킨제작",
  },
  {
    id: 3,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company3.com/logo.png",
    name: "김세현",
    description: "3D 모델 작품 하나하나에 기능넣는걸 좋아합니다",    
    verified: true,
    category: "3D 모델링",
  },

  {
    id: 5,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company5.com/logo.png",
    name: "둡티",
    description: "크고 웅장한 건축물보다 간단한 번들 상품 위주로 선보일 예정입니다.",
    verified: false,
    category: "번들 상품",
  },
  {
    id: 6,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company6.com/logo.png",
    name: "여우비",
    description: "마크 커미션, 외주 6년차 건축가입니다",
    verified: false,
    category: "건축",
  },
  {
    id: 7,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company7.com/logo.png",
    name: "하양이네",
    description: "마인크래프트 2D 리소스 디자이너. 일러스트, 픽셀 아트, 스킨 등 만들고 있습니다.",
    verified: false,
    category: "2D 리소스 디자이너",
  },
  {
    id: 8,
    imageUrl: "https://cnitsstudio-api.com:570/uploads/articles/banner1.jpg",
    logoUrl: "https://company8.com/logo.png",
    name: "최씨",
    description: "현대,동양 장르 및 고건축, 서양 고증 건축을 만들고있습니다",
    verified: false,
    category: "건축",
  },
]; 